// extracted by mini-css-extract-plugin
module.exports = {"holiday_type":"HolidayAbsenceType_holiday_type__37WeI","modal_heading":"HolidayAbsenceType_modal_heading__25zwQ","type":"HolidayAbsenceType_type__i8eXU"};